'use client';

import { useContext, useEffect, useRef, useState } from 'react';

import { HeaderContainerContext } from '../../../organisms/HeaderContainer/header-container.context';

export const useGlobalAlert = (open: boolean) => {
  const [container, setContainer] = useState<Element | null>(null);
  const observerReference = useRef<ResizeObserver | null>(null);
  const { setAlertHeight } = useContext(HeaderContainerContext);

  // Find and set the alert container element
  useEffect(() => {
    const alertContainer = document.querySelector(
      '#global-alert-message-container',
    );
    setContainer(alertContainer);
  }, []);

  // Use ResizeObserver to track height changes (resize, rotation, content changes)
  useEffect(() => {
    if (!container || !setAlertHeight) return;

    if (open) {
      // Create and observe the container for any size changes
      observerReference.current = new ResizeObserver((entries) => {
        for (const entry of entries) {
          const height = entry.contentRect.height;
          setAlertHeight(height);
        }
      });

      observerReference.current.observe(container);
    } else {
      // Clean up observer and reset height when closed
      observerReference.current?.disconnect();
      setAlertHeight(0);
    }

    return () => {
      observerReference.current?.disconnect();
    };
  }, [open, container, setAlertHeight]);

  return { container };
};
